const headRowsVerification = {
  actions: 'Ações',
  name: 'Grupo',
  alert: 'Gerar Ação'
};

export default headRowsVerification;
